// CANONICAL COPY (GH #7115). src/constants/obligations/obl-privacy-pii.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-privacy-pii',
  title: 'Review privacy and PII protection measures',
  description:
    'Verify that the organisation identifies and meets requirements for privacy and protection of personally identifiable information.',
  category: 'compliance',
  scfIds: ['SCF-DAT-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Privacy / PII protection policy is published' },
    { type: 'document-within-sla', description: 'Policy review is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
